module.exports = __webpack_public_path__ + "img/project-management.4dabc199.png";